/* Instagram webview fix */
window._AutofillCallbackHandler = window._AutofillCallbackHandler || function () {};

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.formatMoney = (cents, format) => {
  if (format) format = '${{' + format + '}}';

  if (typeof cents == 'string' && parseFloat(cents) >= 1) {
    cents = cents.replace('.', '');
  }

  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || '${{amount}}';

  // 1.025 to 1.03 (when cents length is 3)
  function toFixed(price) {
    let fixedPrice = (Math.round(price * 100) / 100).toString();

    const [_, decimal] = fixedPrice.split('.');

    if (decimal && decimal.length < 2) {
      fixedPrice = parseFloat(fixedPrice).toFixed(2);
    }

    return fixedPrice;
  }

  function defaultOption(opt, def) {
    return typeof opt == 'undefined' ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    number = Number(number);
    if (isNaN(number) || number == null) {
      return 0;
    }

    number = toFixed(number, precision);

    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? decimal + parts[1] : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

class VariantSelects extends HTMLElement {
  constructor() {
    super();

    // get custom size
    this.tabCustomSize = this.querySelector('.content-tab-size[data-type="custom"]');
    this.sizeDropdown = this.querySelector('size-dropdown');

    // Set valid Information
    this.validInfo = false;

    this.values = {};
    this.properties = {};

    this.keyValues = ['sub-material'];
    this.fakeQty = null;

    this.productId = this.dataset.id;
    this.productType = this.dataset.type;
    this.productHandle = this.dataset.handle;

    this.designOnline = document.querySelector('design-online');
    this.addToCartBtn = document.querySelector('.add-to-cart');

    // Instance Shopify Payment
    this.ShopPay = document.querySelector('shopify-payment-terms');

    this.productData = JSON.parse(this.querySelector('#product-json').textContent);
    this.variantsData = this.productData.variants;
    this.customVariantsData = JSON.parse(this.querySelector('#variants-json').textContent);

    this.productSummary = document.getElementById(`product-summary-${this.dataset.section}`);

    if (this.productSummary) {
      this.units = this.productSummary.querySelector('.units');
      this.unitPriceElement = this.productSummary.querySelectorAll('.unit_price');
      this.unitPriceElementInsert = this.productSummary.querySelector('.unit_inserts_price');
      this.totalPrice = this.productSummary.querySelector('.total_price');
    }

    if (document.querySelector('.unit-price')) {
      this.unitPriceElement = document.querySelectorAll('.unit-price');
    }

    this.productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}, #product-form-${this.dataset.section}-upload, #product-form-${this.dataset.section}-customize `,
    );

    this.quantityTypeComponent = document.querySelector('quantity-type');
    this.productPerInsert = document.querySelector('product-per-insert');
    this.productNotSize = this.dataset.productNotSize === 'true';

    this.selectVariants = this.querySelectorAll('.custom-dropdown-component');
    this.selectVariants.forEach((select) => {
      let name = '';
      if (select && select.dataset.name) {
        name = select.dataset.name.toLowerCase();
      }

      let value = '';
      if (select && select.dataset.value) {
        value = select.dataset.value;
      }

      select.addEventListener('change', () => {
        if (name === 'qty' && this.isCaseQuantity && value === this.maxQuantity) {
          const modalCaseQuantity = document.querySelector('.modal-case-quantity');

          if (modalCaseQuantity) modalCaseQuantity.classList.add('open');
        }

        return this.onVariantChange();
      });

      if (name === 'size') this.sizeDropdown = select;
      if (name === 'qty') this.quantityDropdown = select;
      if (name === 'material') this.materialDropdown = select;
      if (name === 'printing') this.printingDropdown = select;
      if (name === 'production') this.productionDropdown = select;
    });

    this.onVariantChange();

    this.idUser = this.dataset.userid;
    this.note = document.querySelector('.notes .textarea-container textarea');

    if (this.note) {
      this.note.addEventListener('input', (e) => {
        e.preventDefault();

        const textareaContainer = e.target.closest('.textarea-container');
        if (textareaContainer) {
          const counter = textareaContainer.querySelector('.counter');
          if (counter) {
            counter.innerHTML = 500 - e.target.value.length;
            this.properties['_designInstruction'] = e.target.value;
          }
        }
      });
    }
  }

  get validInfo() {
    return this._validInfo;
  }

  set validInfo(valid) {
    if (this.designOnline) {
      this.designOnline.fetching = !valid;
    }

    if (this.addToCartBtn) {
      this.addToCartBtn.innerHTML = 'ADD TO CART';

      if (!valid) {
        this.addToCartBtn.setAttribute('disabled', 'disabled');

        if (this.currentVariant && !this.currentVariant.available) {
          this.addToCartBtn.innerHTML = 'Sold Out';
        }
      } else {
        this.addToCartBtn.removeAttribute('disabled');
      }

      this.addToCartBtn.setAttribute('aria-disabled', !valid);
      this.addToCartBtn.classList.toggle('button-disable', !valid);
    }

    this._validInfo = valid;
    if (this.designOnline) {
      this.designOnline.check()
    }
  }

  get currentVariant() {
    return this._currentVariant;
  }

  set currentVariant(variant) {
    this._currentVariant = variant;

    if (!variant) return;

    if (!('update' in this.dataset)) {
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${variant.id}`);
    }

    this.productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = variant.id || '';
      input.dispatchEvent(new Event('change', {bubbles: true}));
    });
  }

  get quantity() {
    if (this.quantityType === 'package') {
      return parseInt(this.values.package) * parseInt(this.maxQuantity);
    }

    if (this.quantityDropdown) {
      return parseInt(this.quantityDropdown.dataset.value);
    }

    return parseInt(this.values.qty || 1);
  }

  get isFixedQuantity() {
    if (this.isCaseQuantity || !this.quantityDropdown || !this.quantityDropdown.dataset.editable) return false;

    return this.quantityDropdown.dataset.editable === 'false';
  }

  get quantityType() {
    if (!this.quantityTypeComponent || !this.quantityTypeComponent.dataset.value) return 'unit';

    return this.quantityTypeComponent.dataset.value;
  }

  get isDuplicatedProduct() {
    return this.productData.tags.includes('product-feed');
  }

  get isCaseQuantity() {
    return this.productData.tags.includes('case-quantity');
  }

  get maxQuantity() {
    if (!this.isCaseQuantity) return null;

    let maxQuantity = null;

    const currentVariant = this.getCustomVariantByOptions(this.options);
    if (
      currentVariant &&
      currentVariant.priceList &&
      currentVariant.priceList.length > 0 &&
      currentVariant.priceList.slice(-1)[0] &&
      'quantity' in currentVariant.priceList.slice(-1)[0]
    ) {
      maxQuantity = currentVariant.priceList.slice(-1)[0].quantity;
    }

    return maxQuantity;
  }

  get options() {
    return Array.from(this.selectVariants)
      .filter((select) => {
        let name = '';
        if (select && select.dataset.name) {
          name = select.dataset.name.toLowerCase();
        }

        return !['qty'].includes(name);
      })
      .reduce((prev, select) => {
        let name = '';
        if (select && select.dataset.name) {
          name = select.dataset.name.toLowerCase();
        }

        let value = '';
        if (select && select.dataset.value) {
          value = select.dataset.value;
        }

        prev[name] = value;

        return prev;
      }, {});
  }

  get optionKeys() {
    return Object.keys(this.options);
  }

  get optionValues() {
    return Object.values(this.options);
  }

  get priceDoubleSided() {
    let price = 2;

    if (this.quantity === 1 && ['customizeable-box', 'inserts-product'].includes(this.productType)) {
      price = 2.5;
    }

    return price;
  }

  get finalUnitPrice() {
    let finalPrice = this.unitPrice;

    if (this.doubleSidedPrinting) {
      finalPrice *= this.priceDoubleSided;
    }

    if (this.rushDelivery) {
      finalPrice *= 2;
    }

    let quality = '';
    if (this.materialDropdown && this.materialDropdown.dataset.quality) {
      quality = this.materialDropdown.dataset.quality.toLowerCase();
    }

    if (
      this.quantity === 1 &&
      ['customizeable-box', 'inserts-product'].includes(this.productType) &&
      quality === 'premium'
    ) {
      finalPrice *= 1.3;
    }

    return this.toFixed(finalPrice);
  }

  get finalUnitInsertsPrice() {
    let finalPrice = this.unitPrice || 0;

    if (this.rushDelivery) {
      finalPrice *= 2;
    }

    return this.toFixed(finalPrice * 0.65);
  }

  get finalSubtotal() {
    let finalPrice = this.finalUnitPrice;

    if (this.productPerInsert) {
      finalPrice += this.finalUnitInsertsPrice;
    }

    return this.quantity * finalPrice;
  }

  get doubleSidedPrinting() {
    if (!this.values || !this.values.printing) return false;

    return this.values.printing.toLowerCase() === 'double sided';
  }

  get rushDelivery() {
    if (!this.values || !this.values.production) return false;

    return this.values.production.toLowerCase() === 'rush';
  }

  async onVariantChange() {
    this.validInfo = false;

    this.currentVariant = this.getVariantByOptions(this.optionValues);

    /* Show only available options */
    if (['extension-product'].includes(this.productType)) {
      this.updateAvailableOptions();
    }

    /* Update Printing Available Options */
    if (['customizeable-box', 'inserts-product'].includes(this.productType)) {
      this.updatePrintingAvailableOptions();
    }

    /* Update All values into class */
    this.updateAllValues();

    /* Update Production time Text */
    this.updateProductionTime();

    /* Update Unit Prices */
    this.updateUnitPrices();

    /* Render Product Info */
    await this.renderProductInfo();
  }

  getFirstAvailableVariantByOption(option, options) {
    const optionIndex = this.productData.options.findIndex((item) => {
      const a = item.toLowerCase();
      const b = option.toLowerCase();

      return a === b;
    });

    return this.variantsData.find((variant) => {
      const a = options[option].toLowerCase();
      const b = variant.options[optionIndex].toLowerCase();

      return a === b;
    });
  }

  getVariantByOptions(options) {
    return this.variantsData.find(
      (variant) =>
        !variant.options
          .map((option, index) => {
            let a = null;
            if (options[index]) {
              a = options[index].toLowerCase();
            }

            let b = null;
            if (option) {
              b = option.toLowerCase();
            }

            return a === b;
          })
          .includes(false),
    );
  }

  getCustomVariantByOptions(options, optionKeys = null) {
    return this.customVariantsData.find((variant) => {
      const keys = optionKeys || Object.keys(variant.options);
      const vOptions = this.lowercaseKeys(variant.options);

      return !keys
        .map((key) => {
          const optionKey = key.toLowerCase();

          let a = null;
          if (options[optionKey]) {
            a = options[optionKey].toLowerCase();
          }

          let b = null;
          if (vOptions[optionKey]) {
            b = vOptions[optionKey].toLowerCase();
          }

          return a === b;
        })
        .includes(false);
    });
  }

  getUnitPriceForQuantity(priceList, quantity, fixedQuantity = false) {
    let volume;
    let foundVolume = false;

    if (!fixedQuantity) {
      for (let i = 0; i < priceList.length; i++) {
        if (parseInt(priceList[i].quantity) > parseInt(quantity)) {
          foundVolume = true;

          break;
        }

        volume = priceList[i];
      }

      if (!foundVolume && priceList && priceList.length > 0) {
        volume = priceList[priceList.length - 1];
        foundVolume = parseInt(volume.quantity) <= parseInt(quantity);
      }
    } else {
      volume = priceList.find((price) => parseInt(price.quantity) === parseInt(quantity));
      foundVolume = !!volume;
    }

    return volume && foundVolume ? volume.unitPrice : null;
  }

  async renderProductInfo() {
    try {
      let priceList = null;

      const invalidInsertSize = document.querySelector('input.input-size.ng-invalid');

      if (((this.productPerInsert && invalidInsertSize) || !this.values.size) && !this.productNotSize) return;

      let currentOptions = this.options;

      if (['customizeable-box', 'inserts-product'].includes(this.productType)) {
        currentOptions = {
          size: this.values.size,
          material: this.values.material.toLowerCase(),
          printing: 'Outside',
        };

        if (this.values && this.values.printing) {
          currentOptions.printing = this.values.printing.toLowerCase();
        }
      }

      const selectedVariant = this.getCustomVariantByOptions(currentOptions);
      if (selectedVariant && selectedVariant.priceList) {
        priceList = selectedVariant.priceList;
      } else if (['customizeable-box', 'inserts-product'].includes(this.productType)) {
        const url = new URL(`${window.internalApi.baseUrl}/prices`);

        const searchParams = new URLSearchParams();

        const [length, width, height] = this.values.size.split('x');

        searchParams.set('length', length);
        searchParams.set('width', width);
        searchParams.set('height', height);
        searchParams.set('variantId', this.currentVariant.id);

        url.search = searchParams.toString();

        const res = await fetch(url).then((res) => (res.ok ? res.json() : null));

        priceList = res.data || null;
      }

      if (!priceList) throw new Error('Unit price not found');

      this.unitPrice = this.getUnitPriceForQuantity(priceList, this.quantity, this.isFixedQuantity);

      const formCustomSize = document.querySelector('form.custom-size');
      if (formCustomSize) formCustomSize.classList.remove('disabled');

      this.properties.SizeLabel = this.values.size;
      this.properties._customSize = this.values.size;
      this.properties._baseunitprice = this.unitPrice;
      this.properties._unitprice = this.finalUnitPrice;

      this.keyValues.forEach((key) => {
        if (key in this.values) {
          this.properties[`_${key}`] = this.values[key];
        }
      });

      if(parseInt(this.values.qty) === 1 && ['customizeable-box', 'inserts-product'].includes(this.productType)) {
        this.properties._sample = "true";
      }else {
        delete this.properties._sample;
      }

      let suffixQty = '';
      if (['customizeable-box', 'inserts-product'].includes(this.productType)) {
        suffixQty = this.quantity == 1 ? ' (Sample)' : '';
        if (selectedVariant && selectedVariant.priceList && this.doubleSidedPrinting) {
          if (this.quantity > 1) {
            this.unitPrice = this.unitPrice / 2;
            this.properties._baseunitprice = this.unitPrice;
            this.properties._unitprice = this.finalUnitPrice;
          } /* else {
            this.unitPrice = this.unitPrice / 2.5;
            this.properties._baseunitprice =  this.unitPrice;
            this.properties._unitprice = this.finalUnitPrice;
          } */
        }

        this.properties = {
          ...this.properties,
          _printing: this.values.printing,
          _production: this.values.production,
        };

        if (this.productPerInsert) {
          this.properties['_unitpriceinsert'] = this.finalUnitInsertsPrice;

          if (this.unitPriceElement) {
            Array.from(this.unitPriceElement).forEach((priceElement) => {
              priceElement.closest('.line').querySelector('.text').textContent = 'Unit Mailer Price';
            });
          }

          if (this.unitPriceElementInsert) {
            this.unitPriceElementInsert.closest('.line').classList.remove('hidden');
            this.unitPriceElementInsert.textContent = Shopify.formatMoney(this.finalUnitInsertsPrice);
          }

          const insertItems = document.querySelectorAll('.size-item-wrapper');
          if (insertItems.length > 0) {
            this.properties['_inserts'] = Array.from(insertItems).reduce((prevInserts, product) => {
              const insert = Array.from(product.querySelectorAll('.input-component')).reduce((prevInsert, item) => {
                const input = item.querySelector('input');

                return [...prevInsert, input.value];
              }, []);

              return [...prevInserts, insert.join('x')];
            }, []);
          }
        }
      }

      if (this.isCaseQuantity && this.quantityType === 'package') {
        let maxQuantity = null;

        let valFakeQty = false;

        if (priceList && priceList.length > 0) {
          let currentPriceList = priceList.slice(-1);

          if (currentPriceList && currentPriceList.length > 0 && currentPriceList[0].quantity) {
            maxQuantity = currentPriceList[0].quantity;
          }
          if (currentPriceList && currentPriceList.length > 0 && "fakeQty" in  currentPriceList[0] && currentPriceList[0].fakeQty) {
            valFakeQty = true;
            maxQuantity = currentPriceList[0].fakeQty;
          }
        }
        if(valFakeQty) this.fakeQty = priceList.slice(-1).fakeQty;
        this.properties._caseQuantity = maxQuantity;
      }

      this.productForms.forEach((productForm) => {
        const baseUnitPriceInput = productForm.querySelector('[name="properties[_baseunitprice]"]');
        const unitPriceInput = productForm.querySelector('[name="properties[_unitprice]"]');
        const quantityInput = productForm.querySelector('[name="quantity"]');

        if (quantityInput) quantityInput.value = this.quantity;
        if (unitPriceInput) unitPriceInput.value = this.properties._unitprice;
        if (baseUnitPriceInput) baseUnitPriceInput.value = this.properties._baseunitprice;
      });

      if (this.units) {
        this.units.textContent = `${this.quantity}${suffixQty}`;
        const inputQty = document.querySelector('product-form input[name="quantity"]');
        if (inputQty) inputQty.value = this.quantity;
      }

      if (this.unitPriceElement) {
        Array.from(this.unitPriceElement).forEach((priceElement) => {
          priceElement.textContent = Shopify.formatMoney(this.finalUnitPrice) === "$0" ? "$0.00": Shopify.formatMoney(this.finalUnitPrice);
        });
      }

      if (this.totalPrice) {
        if(['customizeable-box', 'inserts-product'].includes(this.productType)) {
          
          const customerDiscount = document.querySelector('.discount-amount') ? 0.1 : 0;
          if(customerDiscount == 0){
            this.totalPrice.innerHTML = Shopify.formatMoney(this.finalSubtotal) + '<small> + Shipping</small>';
          }else{
            this.totalPrice.innerHTML = `<span class="price-with-discount">${Shopify.formatMoney(this.finalSubtotal - (this.finalSubtotal * customerDiscount))}</span> <span class='original-price-line-through'>${Shopify.formatMoney(this.finalSubtotal)}</span>  <small> + Shipping</small>`;
          }
        } else {
          this.totalPrice.innerHTML = Shopify.formatMoney(this.finalSubtotal) === "$0" ? "-": Shopify.formatMoney(this.finalSubtotal) + '<small> + Shipping</small>';
        }
      }

      this.updateShopPay(this.finalSubtotal);

      /* Active Buttons */
      if(['customizeable-box', 'inserts-product'].includes(this.productType)) {
        this.validInfo = !!this.currentVariant && !!this.currentVariant.available && this.unitPrice >= 0;
      }else {
        this.validInfo = !!this.currentVariant && !!this.currentVariant.available && !!this.unitPrice;
      }


      if (this.tabCustomSize && this.tabCustomSize.classList.contains('active')) {
        if(['customizeable-box', 'inserts-product'].includes(this.productType)) {
          this.validInfo = !!this.currentVariant && !!this.currentVariant.available && this.unitPrice >= 0;
        } else {
          this.validInfo =
            !!this.currentVariant &&
            !!this.currentVariant.available &&
            !!this.unitPrice &&
            this.sizeDropdown.isValidCustomSize;
        }
      }
    } catch (error) {
      console.log(error);

      if (this.totalPrice) {
        this.totalPrice.textContent = '-';
      }

      if (this.unitPriceElement) {
        Array.from(this.unitPriceElement).forEach((priceElement) => {
          priceElement.textContent = '-';
        });
      }

      if (this.productPerInsert) {
        this.unitPriceElementInsert.closest('.line').classList.remove('hidden');
        this.unitPriceElementInsert.textContent = '-';
      }
    }
  }

  updateAvailableOptions() {
    const selects = Array.from(this.selectVariants).filter((select) => {
      let name = '';
      if (select && select.dataset.name) {
        name = select.dataset.name.toLowerCase();
      }

      return ['size', 'qty', 'package', 'print-colors', 'sub-material', 'weight', 'paper-weight', 'cubic-feet', 'material'].includes(name);
    });

    selects.forEach((select) => {
      let name = '';
      if (select && select.dataset.name) {
        name = select.dataset.name.toLowerCase();
      }

      let currentOptions = this.options;

      let maxQuantity = null;
      if (this.isCaseQuantity) {
        const currentVariant = this.getCustomVariantByOptions(currentOptions);
        let valFakeQty = false;

        if (currentVariant && currentVariant.priceList && currentVariant.priceList.length > 0) {
          let currentPriceList = currentVariant.priceList.slice(-1);

          if (currentPriceList && currentPriceList.length > 0 && currentPriceList[0].quantity) {
            maxQuantity = currentPriceList[0].quantity;
          }

          if (currentPriceList && currentPriceList.length > 0 && "fakeQty" in  currentPriceList[0] && currentPriceList[0].fakeQty) {
            valFakeQty = true;
            maxQuantity = currentPriceList[0].fakeQty;
          }
        }

        if(valFakeQty) this.fakeQty = maxQuantity;
      }
      let objectValidate = {
        'paper-weight': ["size", "paper-weight"],
        'cubic-feet': ["type", "cubic-feet"],
        'material': ["size", "material"],
      }

      let changeValue =  false;
      if(['paper-weight', 'cubic-feet', 'material'].includes(name)) {
        const selectValue = select.dataset.value;
        select.querySelectorAll('[role="option"]').forEach((option) => {
          const optionValue = option.dataset.value;
          const selectedVariant = this.getCustomVariantByOptions(currentOptions, objectValidate[name]);
          const value = selectedVariant ? selectedVariant.options[name]: null;
          if (selectValue === optionValue && !value) changeValue = true;
        });
      }

      /* Set Unit Prices by Options */
      select.querySelectorAll('[role="option"]').forEach((option) => {
        if (name in currentOptions) currentOptions[name] = option.dataset.value;

        const selectedVariant = this.getCustomVariantByOptions(currentOptions);

        let quantity = this.quantity;
        if (name === 'qty') quantity = option.dataset.value;

        let selectedPrice = null;
        if (selectedVariant && selectedVariant.priceList) {
          selectedPrice = this.getUnitPriceForQuantity(selectedVariant.priceList, quantity, this.isFixedQuantity);
        }

        if (['sub-material', 'weight', 'print-colors'].includes(name)) {
          const isHidden = !selectedVariant || !selectedPrice;
          if (isHidden) option.setAttribute('aria-hidden', isHidden);
          else option.removeAttribute('aria-hidden');
        }

        if(['paper-weight', 'cubic-feet', 'material'].includes(name)) {
          let isHidden = false;
          const selectedVariant = this.getCustomVariantByOptions(currentOptions, objectValidate[name]);
          const value = selectedVariant ? selectedVariant.options[name]: null;
          if (changeValue && value) {
            changeValue = false;
            select.dataset.value = value;
            option.click();

          }
          if (!selectedVariant) isHidden = true;
          if (isHidden) option.setAttribute('aria-hidden', isHidden);
          else option.removeAttribute('aria-hidden');
        }

        if (name === 'qty') {
          let isHidden = false;
          let caseQuantityHidden = false;
          if (maxQuantity) caseQuantityHidden = option.dataset.value > maxQuantity;

          isHidden = !selectedVariant || !selectedPrice || caseQuantityHidden;
          if (isHidden) option.setAttribute('aria-hidden', isHidden);
          else option.removeAttribute('aria-hidden');
        }
      });

      /* Set Quantity Active */
      if (
        ((name === 'qty' && this.quantityType === 'unit') || ['sub-material', 'weight'].includes(name)) &&
        select.currentOption &&
        select.currentOption.hasAttribute('aria-hidden')
      ) {
        select.setFirstAvailableOption();
      }

      /* Set Package Active */
      if (name === 'package') {
        if (select.setPackageUnits && typeof select.setPackageUnits === 'function') {
          select.setPackageUnits();
        } else if (customElements.get('package-dropdown') && select instanceof customElements.get('package-dropdown')) {

          this.maxQuantity = maxQuantity;
          select.querySelectorAll('.unit-for-package').forEach(item => {
            item.textContent = maxQuantity || this.caseQty || '###';
          });
        }
      }
    });
  }

  updatePrintingAvailableOptions() {
    if (!this.printingDropdown || !this.sizeDropdown) return;

    let size = null;
    if (this.sizeDropdown.dataset.value) {
      size = this.sizeDropdown.dataset.value.toLowerCase();
    }

    if (!size) return;

    let currentOptions = this.options;

    this.printingDropdown.querySelectorAll('[role="option"]').forEach((option) => {
      currentOptions['printing'] = option.dataset.value;

      const selectedVariant = this.getCustomVariantByOptions(currentOptions, ['printing', 'material']);

      let [length, width, height] = size.split('x');
      if (
        currentOptions.material.toLowerCase() === 'white ink on kraft' &&
        currentOptions.printing.toLowerCase() === 'double sided' &&
        parseFloat(length) < 12 &&
        parseFloat(width) < 12 &&
        parseFloat(height) < 12
      ) {
        option.removeAttribute('aria-hidden');
      } else {
        if (!selectedVariant) option.setAttribute('aria-hidden', true);
        else option.removeAttribute('aria-hidden');
      }
    });

    if (this.printingDropdown.currentOption && this.printingDropdown.currentOption.hasAttribute('aria-hidden')) {
      this.printingDropdown.setFirstAvailableOption();
    }
  }

  updateShopPay(subtotal) {
    if (!this.ShopPay) return;

    const ShopifyMeta = JSON.parse(this.ShopPay.getAttribute('shopify-meta'));

    ShopifyMeta.min_price = Shopify.formatMoney(subtotal / 4);

    ShopifyMeta.variants.forEach((variant) => {
      variant.full_price = Shopify.formatMoney(subtotal);
      variant.price_per_term = Shopify.formatMoney(subtotal / 4);
    });

    this.ShopPay.setAttribute('shopify-meta', JSON.stringify(ShopifyMeta));
  }

  updateAllValues() {
    if (!this.selectVariants) return;

    this.values = {};
    this.properties = {};

    this.selectVariants.forEach((select) => {
      let key = null;
      if (select && select.dataset.name) {
        key = select.dataset.name.toLowerCase();
      }

      let value = null;
      if (select && select.dataset.value) {
        value = select.dataset.value.toLowerCase();
      }

      let customValue = null;
      if (select && select.dataset.customValue) {
        customValue = select.dataset.customValue.toLowerCase();
      }

      if (key != '' && value != '') {
        this.values[key] = value === 'custom' && customValue ? customValue : value;
      }
    });

    if (this.isDuplicatedProduct && this.productType === 'customizeable-box') {
      const [_, tempPrinting, tempQty] = this.productData.title
        .toLowerCase()
        .replace(' printing', '')
        .replace(' units', '')
        .split('/');

      this.values['qty'] = tempQty ? parseInt(tempQty) : 1;
      this.values['printing'] = tempPrinting || 'Outside';
      this.values['production'] = 'Standard';
    }

    if (this.isDuplicatedProduct && this.productType === 'extension-product') {
      const [_, tempQty] = this.productData.title.toLowerCase().replace(' units', '').split('/');

      this.values['qty'] = tempQty ? parseInt(tempQty) : 1;

      if (this.isCaseQuantity) {
        this.values['package'] = 1;
      }
    }

    localStorage.setItem(this.productHandle, JSON.stringify(this.values));
  }

  updateUnitPrices() {
    const selects = Array.from(this.selectVariants).filter((select) => {
      let name = '';
      if (select && select.dataset.name) {
        name = select.dataset.name.toLowerCase();
      }

      return ['size', 'qty', 'package', 'lb'].includes(name);
    });
    selects.forEach((select) => {
      let unitPriceByName = select.dataset.unitPriceByName;
      if (!unitPriceByName) return;

      let currentOptions = this.options;

      /* Set Unit Prices by Options */
      let name = '';
      if (select && select.dataset.name) {
        name = select.dataset.name.toLowerCase();
      }

      select.querySelectorAll('[role="option"]').forEach((option) => {
        if (name in currentOptions) currentOptions[name] = option.dataset.value;

        const selectedVariant = this.getCustomVariantByOptions(currentOptions);

        let quantity = this.quantity;
        if (name === 'qty') quantity = option.dataset.value;

        let selectedPrice = null;
        if (selectedVariant && selectedVariant.priceList) {
          selectedPrice = this.getUnitPriceForQuantity(selectedVariant.priceList, quantity, this.isFixedQuantity);
        }

        const priceElem = option.querySelector('.price');
        if (priceElem) {
          priceElem.textContent = selectedVariant && selectedPrice ? Shopify.formatMoney(parseFloat(selectedPrice)) : 'N/A';
        }
        const tempDropdown = option.closest('.custom-dropdown-component');
        if(tempDropdown && tempDropdown.dataset.priceForQty === 'true') {
          priceElem.textContent = selectedVariant && selectedPrice ? Shopify.formatMoney(parseFloat(selectedPrice)*option.dataset.value) : 'N/A';
        }


      });

      /* Set LabelDescription */
      if (name === 'size' && this.printingDropdown) {
        select.querySelectorAll('.size-label-desc').forEach((label) => {
          label.textContent = this.printingDropdown.dataset.value;
        });
      }

      /* Set Bottom Note */
      const bottom_note = select.querySelector('.bottom .info');
      if (bottom_note && unitPriceByName) {
        if (unitPriceByName === 'qty') {
          bottom_note.textContent = `Unit price based on ${unitPriceByName}: ${this.quantity}`;
        } else {
          bottom_note.textContent = `Unit price based on ${unitPriceByName}: ${
            this.values[unitPriceByName.toLowerCase()]
          }`;
        }
      }
    });
  }

  updateProductionTime() {
    if (!this.productionDropdown) return;

    const defaultTimes = {
      standard: 'Estimated to Ship in 7 - 10 business days after proof approval',
      rush: 'Estimated to Ship in 3 - 6 business days after proof approval',
    };

    if (this.quantity >= 1000) {
      defaultTimes.standard = 'Estimated to Ship in 12 - 15 business days after proof approval';
      defaultTimes.rush = 'Estimated to Ship in 12 - 15  business days after proof approval';
    }

    let infoElem = this.productionDropdown.querySelector('.text-info-select');
    if(!infoElem) infoElem = document.querySelector('.estimated_to_v2 .text-info-select');
    if (!infoElem) return;

    let production = 'standard';
    if (this.productionDropdown.dataset.value) {
      production = this.productionDropdown.dataset.value.toLowerCase();
    }

    infoElem.textContent = defaultTimes[production];
  }

  toFixed(number) {
    if (!number) return number;

    return parseFloat(Math.round(number * 100) / 100);
  }

  lowercaseKeys(obj) {
    return Object.entries(obj).reduce((carry, [key, value]) => {
      carry[key.toLowerCase()] = value;

      return carry;
    }, {});
  }
}

customElements.define('variant-selects', VariantSelects);

//Change rewards z-index
function _waitForElement(selector, delay = 50, tries = 100) {
  const element = document.querySelector(selector);

  if (!window[`__${selector}`]) {
    window[`__${selector}`] = 0;
    window[`__${selector}__delay`] = delay;
    window[`__${selector}__tries`] = tries;
  }

  function _search() {
    return new Promise((resolve) => {
      window[`__${selector}`]++;
      setTimeout(resolve, window[`__${selector}__delay`]);
    });
  }

  if (element === null) {
    if (window[`__${selector}`] >= window[`__${selector}__tries`]) {
      window[`__${selector}`] = 0;
      return Promise.resolve(null);
    }

    return _search().then(() => _waitForElement(selector));
  } else {
    return Promise.resolve(element);
  }
}

const start = (async () => {
  const $el = await _waitForElement('#smile-ui-lite-launcher-frame-container');

  if ($el) {
    $el.style.zIndex = '0';
  }
})();

//Contact form textarea focus
const formWrapper = document.querySelector('.support-form-wrapper');
if (formWrapper) {
  const observer = new MutationObserver(formMutation);
  const config = {childList: true};

  observer.observe(formWrapper, config);

  function formMutation() {
    if (formWrapper.querySelector('.hs-fieldtype-textarea.field.hs-form-field textarea')) {
      const textAreaWrapper = formWrapper.querySelector('.hs-fieldtype-textarea.field.hs-form-field');
      const textAreaInput = formWrapper.querySelector('.hs-fieldtype-textarea.field.hs-form-field textarea');

      textAreaInput.addEventListener('focus', () => {
        textAreaWrapper.classList.add('focused');
      });

      textAreaInput.addEventListener('focusout', () => {
        if (textAreaInput.value === '') {
          textAreaWrapper.classList.remove('focused');
        }
      });
    }
  }
}

const openChatBtns = document.querySelectorAll('a[href="#open-chat"]');
if (openChatBtns) {
  openChatBtns.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();

      if (window.HubSpotConversations) {
        window.HubSpotConversations.widget.open();
      } else {
        window.hsConversationsOnReady = [
          () => {
            window.HubSpotConversations.widget.open();
          },
        ];
      }
    });
  });
}

const details = document.querySelectorAll('details');
details.forEach((targetDetail) => {
  targetDetail.addEventListener('click', () => {
    details.forEach((detail) => {
      if (detail !== targetDetail) {
        detail.removeAttribute('open');
      }
    });
  });
});

const SizeChartEvent = document.querySelectorAll('.table-row.table-row-body .cell');
SizeChartEvent.forEach((e) => {
  e.addEventListener('click', () => {
    window.lintrk('track', {conversion_id: 12984585});
  });
});

const CustomDropdownComponent = document.querySelectorAll('.custom-dropdown-component');
CustomDropdownComponent.forEach((e) => {
  window.addEventListener('scroll', () => {
    e.ariaHidden = true;
  });
});
